import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const TrafficSourcesPage = () =>
  import('@/apps/adok/pages/traffic-sources').then((m) => m.TrafficSourcesPage)
const TrafficSourcePresetsPage = () =>
  import('@/apps/adok/pages/traffic-source-presets').then(
    (m) => m.TrafficSourcePresetsPage
  )

const trafficSourcesRoutes: RouteRecordRaw[] = [
  {
    path: '/traffic-sources',
    component: Layout,
    redirect: '/traffic-sources/presets',
    children: [
      {
        path: 'sources',
        name: 'traffic-source-sources',
        component: TrafficSourcesPage,
        meta: {
          title: 'Traffic sources'
        }
      },
      {
        path: 'sources/new',
        name: 'traffic-source-sources-new',
        component: TrafficSourcesPage,
        meta: {
          title: 'New traffic source',
          hidden: true
        }
      },
      {
        path: 'sources/:sourceId/edit',
        name: 'traffic-source-sources-edit',
        component: TrafficSourcesPage,
        meta: {
          title: 'Edit traffic source',
          hidden: true
        }
      },
      {
        path: 'sources/:sourceId/blockers',
        name: 'traffic-source-sources-blockers',
        component: TrafficSourcesPage,
        meta: {
          title: 'Block creative on traffic source',
          hidden: true
        }
      },
      {
        path: 'sources/:sourceId/blockers/new',
        name: 'traffic-source-sources-blockers-new',
        component: TrafficSourcesPage,
        meta: {
          title: 'Block creative on traffic source',
          hidden: true
        }
      },

      {
        path: 'presets',
        name: 'traffic-source-presets',
        component: TrafficSourcePresetsPage,
        meta: {
          title: 'Traffic source presets'
        }
      },
      {
        path: 'presets/new',
        name: 'traffic-source-presets-new',
        component: TrafficSourcePresetsPage,
        meta: {
          title: 'New traffic source',
          hidden: true
        }
      },
      {
        path: 'presets/:presetId/edit',
        name: 'traffic-source-presets-edit',
        component: TrafficSourcePresetsPage,
        meta: {
          title: 'Edit traffic source',
          hidden: true
        }
      },
      {
        path: 'presets/:presetCode/credentials',
        name: 'traffic-source-presets-credentials',
        component: TrafficSourcePresetsPage,
        meta: {
          title: 'Traffic source credentials',
          hidden: true
        }
      },
      {
        path: 'presets/:presetId/blockers',
        name: 'traffic-source-presets-blockers',
        component: TrafficSourcePresetsPage,
        meta: {
          title: 'Block creative on traffic source',
          hidden: true
        }
      },
      {
        path: 'presets/:presetId/blockers/new',
        name: 'traffic-source-presets-blockers-new',
        component: TrafficSourcePresetsPage,
        meta: {
          title: 'Block creative on traffic source',
          hidden: true
        }
      }
    ]
  }
]

export default trafficSourcesRoutes
